module.exports = __webpack_public_path__ + "img/process-strategy.6f452755.jpg";